import React from "react";

const ReportedItems = () => {
  return (
    <div>
      <h2 className="text-xl font-bold text-center my-6">Reported Items</h2>
    </div>
  );
};

export default ReportedItems;
